// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React from 'react';
import { CardTypes } from '../../../types/Model';
import LoadingIcon from '../../LoadingIcon';
import NewCard from '../../NewCard';
import { ProductCard } from '../../NewCard/types';
import { S } from './styles';
import { FormattedMessage } from 'react-intl';

interface ListResultProps {
  isFetching: boolean;
  isMoreFetching: boolean;
  list: ProductCard[];
  type: CardTypes;
  currentKeyword: string;
  updatePage: () => void;
}

function ListResult({
  isFetching,
  isMoreFetching,
  list,
  currentKeyword,
  updatePage,
  ...otherProps
}: ListResultProps): JSX.Element {
  const handleScroll = (event: React.UIEvent<HTMLDivElement, UIEvent>) => {
    const target = event.target as HTMLDivElement;
    if (Math.ceil(target.scrollTop + target.clientHeight) >= target.scrollHeight) { // Fix detect scroll to bottom when zooming
      updatePage();
    }
  }

  if (isFetching && !isMoreFetching) {
    return (
      <S.MessageContainer>
        <LoadingIcon size={20} />
      </S.MessageContainer>
    )
  }

  if (list.length === 0) {
    return (
      <S.MessageContainer>
        <S.NoResultImage />
        <S.NoResultTitle><FormattedMessage id="C005" /></S.NoResultTitle>
      </S.MessageContainer>
    )
  }

  return (
    <S.Container onScroll={handleScroll}>
      <S.CardContainer>
        {
          list.map((card: ProductCard) => {
            card.type = otherProps.type;
            switch (card.type) {
              case CardTypes.COURSE:
                return (
                  <NewCard
                    key={card.id}
                    id={card.id}
                    type={card.type}
                    name={card.name}
                    domainIds={card.domainIds}
                    totalDuration={card.totalDuration}
                    levelId={card.levelId}
                    platformId={card.platformId}
                    imageUrl={card.imageUrl}
                    language={card.language}
                    vodCount={card.vodCount}
                    labCount={card.labCount}
                    challengeCount={card.challengeCount}
                    assessmentCount={card.assessmentCount}
                    examCount={card.examCount}
                    completionProgress={card.completionProgress}
                  />
                )
              case CardTypes.LAB:
                return (
                  <NewCard
                    key={card.id}
                    id={card.id}
                    type={card.type}
                    name={card.name}
                    domainIds={card.domainIds}
                    totalDuration={card.totalDuration}
                    levelId={card.levelId}
                    platformId={card.platformId}
                    imageUrl={card.imageUrl}
                    language={card.language}
                  />
                )
              case CardTypes.CHALLENGE:
                return (
                  <NewCard
                    key={card.id}
                    id={card.id}
                    type={card.type}
                    name={card.name}
                    domainIds={card.domainIds}
                    totalDuration={card.totalDuration}
                    levelId={card.levelId}
                    platformId={card.platformId}
                    imageUrl={card.imageUrl}
                    language={card.language}
                  />
                )
              case CardTypes.EXAM:
                return (
                  <NewCard
                    key={card.id}
                    id={card.id}
                    type={card.type}
                    name={card.name}
                    domainIds={card.domainIds}
                    totalDuration={card.totalDuration}
                    levelId={card.levelId}
                    platformId={card.platformId}
                    imageUrl={card.imageUrl}
                    language={card.language}
                    multiSelect={card.multiSelect}
                    qna={card.qna}
                  />
                )
              default:
                return null;
            }
          })
        }
      </S.CardContainer>
      {isMoreFetching && (
        <S.MoreResultLoadingContainer>
          <S.MoreResultLoadingIcon />
          <S.MoreResultLoadingTitle>Loading...</S.MoreResultLoadingTitle>
        </S.MoreResultLoadingContainer>
      )}
    </S.Container>
  )
}

export { ListResult as default };
